module.exports = __webpack_public_path__ + "img/search-header-with-nav-honda.2badabb0.png";